var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-center-sp"},[_c('div',{staticClass:"about-body flex flex-col scroll"},[_c('div',{staticClass:"margin-top-xxl margin-bottom-xl flex flex-center-sp font-xxl font-bold"},[_vm._v("更新日志")]),_vm._v(" "),_c('time-axis',{attrs:{"timeData":_vm.timeData}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fb7dee2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/UpdateLog.vue
// module id = null
// module chunks = 